module.exports = __webpack_public_path__ + "img/visa.e3f03107.svg";